module.exports = {render: function () {with(this){return _c('svg',{staticClass:"checkmark",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.2 15","width":"19","height":"15"}},[_c('path',{staticClass:"st0",attrs:{"data-ignore":"true","d":"M1 1h13v13H1z","id":"quardato"}}),_c('g',{attrs:{"id":"check"}},[_c('path',{staticClass:"st1",attrs:{"data-ignore":"true","d":"M0 0h15v15H0z"}}),_c('path',{staticClass:"st2",attrs:{"id":"Path_213","d":"M4.7 5.3l4.2 4.4 9.4-8.3"}})])])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkbox.svg
// module id = kk2J
// module chunks = 0